import { lazyGetPendingPermissionErrorCode } from 'owa-attachment-block-on-send';

export async function getPendingPermissionTelemetryErrorCode(composeId: string): Promise<string> {
    const getPendingPermissionErrorCode = await lazyGetPendingPermissionErrorCode.import();
    return Promise.resolve(getPendingPermissionErrorCode(composeId));
}
